import BaseService from "services/BaseService";

class MasterPackageService extends BaseService {
  listPending = async () => {
    return await this._api.post("master/package/upgrade-request/pending");
  };

  approve = async ({ request_id }) => {
    return await this._api.post("master/package/upgrade-request/approve", { request_id });
  };
}

export default MasterPackageService;
